// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WGxE","index":"styles_index__1kOCW"};